import { CccCalendarClientOption } from '../api/cccCalendarApi';
import { RecuperacaoMarcacao, RetencaoMarcacao } from '../api/cccApi';

type CalendarMarcacao = RecuperacaoMarcacao | RetencaoMarcacao;

function buildMarcacaoCalendarClient(
  m: CalendarMarcacao,
  clientType: 'recuperacao' | 'retencao',
  routePath: string
): CccCalendarClientOption {
  const fd = (m.form_data || {}) as Record<string, unknown>;
  const nif = fd.nifEmpresa ?? fd.nif;
  const contacto =
    m.contacto_cliente || fd.contactoCliente || fd.telefone || fd.contactoRepresentante;
  const ref = m.marcacao_id || String(m.id);
  return {
    client_type: clientType,
    client_ref: ref,
    label: (m.nome_empresa || ref).trim(),
    subtitle: [m.nome_responsavel, nif ? `NIF ${nif}` : null].filter(Boolean).join(' · '),
    route_path: routePath,
    route_query: { marcacao: ref },
    snapshot: {
      marcacao_id: ref,
      nome_empresa: m.nome_empresa,
      nome_responsavel: m.nome_responsavel,
      contacto,
      nif,
      produto: m.produto,
    },
  };
}

/** Build calendar client link from an open Recuperação lead (claimed marcação). */
export function buildRecuperacaoCalendarClient(m: RecuperacaoMarcacao): CccCalendarClientOption {
  return buildMarcacaoCalendarClient(m, 'recuperacao', '/recuperacao');
}

/** Build calendar client link from an open Retenção lead (claimed marcação). */
export function buildRetencaoCalendarClient(m: RetencaoMarcacao): CccCalendarClientOption {
  return buildMarcacaoCalendarClient(m, 'retencao', '/retencao');
}

export function defaultCalendarEventTitle(m: CalendarMarcacao): string {
  const name = (m.nome_empresa || m.marcacao_id || 'Cliente').trim();
  return `Contacto — ${name}`;
}

export function defaultCalendarSlotTimes(): { start: Date; end: Date } {
  const start = new Date();
  start.setSeconds(0, 0);
  start.setMinutes(0);
  if (start.getHours() < 8) {
    start.setHours(9, 0, 0, 0);
  } else if (start.getHours() >= 19) {
    start.setDate(start.getDate() + 1);
    start.setHours(9, 0, 0, 0);
  } else {
    start.setHours(start.getHours() + 1);
  }
  const end = new Date(start);
  end.setHours(end.getHours() + 1);
  return { start, end };
}
